import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@meno/ui/i18n/index'
import './index.css'
import App from './App'
import { initSentry } from './lib/sentry'
import { reportBuild } from '@meno/ui/lib/reportBuild'
import { registerFrameServiceWorker } from './lib/push'

// Init Sentry first so errors during i18n bootstrap / root creation /
// first render are captured. No-op when VITE_SENTRY_DSN_FRAME is unset.
initSentry()

// Live version reporting for the admin Ops pages (see reportBuild.ts).
reportBuild('frame')

// Installable app + web push (notification-only worker; caches nothing).
registerFrameServiceWorker()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
